/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 11:14:50
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-15 16:17:16
 */

export default {
    path: 'audit',
    component: () => import( /* webpackChunkName: "autidt-list" */ '@/pages/common/Empty'),
    meta: {
      title: '业务审核',
      cate:'所有商户管理'
    },
    children: [
      {
        path: 'bill',
        component: () => import(/* webpackChunkName: "autidt-bill" */ '@/pages/audit/Bill'),
        meta: {title:'业务清单审核'},
      },
      {
        path: 'contract',
        component: () => import(/* webpackChunkName: "autidt-contract" */ '@/pages/audit/Contract'),
        meta: {title:'合同审核'},
      },
      {
        path: 'task',
        component: () => import(/* webpackChunkName: "autidt-task" */ '@/pages/audit/Task'),
        meta: {title:'结算审核'},
      },
      {
        path: 'view',
        component: () => import(/* webpackChunkName: "autidt-view" */ '@/pages/audit/BatchDetail'),
        meta: {title:'审核明细'},
      }
    ]
  }
